const tr = {
  name: "名稱",
  category: "類目",
  addProduct: "新增商品",
  addOrEditProduct: "新增/修改商品",
  addOrEditCategoryProduct: "新增/修改類目商品",
  editCategoryInfo: "修改商品類目資訊",
  plCode: "請輸入分類編碼",
  plName: "請輸入分類名稱",
  selCategory: "請選擇商品類目",
  code: "編碼",
  addCategory: "新增類別目",
  addSubCategory: "新增子類別目",
  noDelTips1: "該類別目下有產品，無法進行刪除。 ",
  tips: "提示",
  conTips: "確定刪除該類別目嗎？ ",
  noDelTips2: "該類別目下有子類別目，無法進行刪除。 ",
  plEnterName: "請輸入類別目名稱",
  productList: "商品列表",
  delCategory: "刪除類別目",
  plSearch: "請輸入關鍵字搜尋",
  fetchFail: "商品類目查詢失敗",

  storeType: "庫存類型：",
  storeTypeCloumn:'庫存類型',
  storeTypeNum: "數量",
  storeTypeCode: "條碼",
  hsCode: 'HS編碼',
  plHsCode: '請輸入HS編碼',
  plChooseType: '請選擇類型',
  all: '全部',
  setCategoryOrg: '設置類目分管部門'
};

export default tr;